import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { createNewDealer } from '../../store/actions';

import BaseModal from '../../components/BaseModal';
import BaseFormWithAction from '../../components/BaseFormWithAction';

import {
  REQUIRED,
  EMAIL,
  PHONE
} from '../../utils/formValidation';

const CreateNewDealerModal = (props) => {

  const submit = async (data) => {
    await props.createNewDealer(data, (to) => props.history.push(`/dealers/${to}`));
  }

  const formData = [
    {
      name: 'name',
      labelName: 'Dealer Name',
      type: 'text',
      validation: [REQUIRED]
    },
    {
      name: 'brand',
      labelName: 'Auto Make',
      type: "select",
      selectOptions: {
        options: [
          'Acura',
          'Alfa Romeo',
          'Audi',
          'BMW',
          'Bentley',
          'Benz',
          'Bugatti',
          'Chrysler',
          'Ford',
          'GM',
          'Honda',
          'Hyundai',
          'Infiniti',
          'Jaguar',
          'Kia',
          'LandRover',
          'Lexus',
          'Mazda',
          'Mitsubishi',
          'Nissan',
          'Porsche',
          'Subaru',
          'Toyota',
          'Volkswagen',
          'Volvo',
          'Multi_Brand_1'
        ],
        prop: 'Make'
      },
      validation: [REQUIRED]
    },
    {
      name: 'address',
      labelName: 'Street Address',
      type: 'text',
      validation: [REQUIRED]
    },
    {
      name: 'zip',
      labelName: 'Zip',
      type: 'text',
      validation: [REQUIRED]
    },
    // {
    //   name: 'email',
    //   labelName: 'Email',
    //   type: 'text',
    //   validation: [REQUIRED, EMAIL]
    // },
    // {
    //   name: 'phone',
    //   labelName: 'Phone',
    //   type: 'text',
    //   validation: [REQUIRED, PHONE]
    // },
  ]

  const body = (
    <div className="create-new-dealer__body">
      <h2 className="create-new-dealer__title modal__body-title">
        New Dealer
      </h2>
      <BaseFormWithAction
        formData={formData}
        buttonName="Add Dealer"
        onSubmit={submit}
      />
    </div>
  );

  return (
    <BaseModal body={body} footer={null} onClose={props.onClose}/>
  );
}

export default connect(null, { createNewDealer })(withRouter(CreateNewDealerModal));